(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9359],{

/***/ 95186:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 50337:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _objectSpread;
var _definePropertyMjs = _interopRequireDefault(__webpack_require__(79361));
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            (0, _definePropertyMjs).default(target, key, source[key]);
        });
    }
    return target;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


/***/ }),

/***/ 44020:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 92806:
/***/ (function(module) {

"use strict";

module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),

/***/ 96874:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 38845:
/***/ (function(module) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),

/***/ 5976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 56560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    defineProperty = __webpack_require__(38777),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 45357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 30061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56560),
    shortOut = __webpack_require__(21275);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 21275:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 81629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseDelay = __webpack_require__(38845),
    baseRest = __webpack_require__(5976);

/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = baseRest(function(func, args) {
  return baseDelay(func, 1, args);
});

module.exports = defer;


/***/ }),

/***/ 19811:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _asyncToGenerator = (__webpack_require__(60932)/* ["default"] */ .Z);
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
var _objectSpread = (__webpack_require__(50337)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var environments = {
    PRODUCTION: "production",
    STAGING: "staging",
    DEVELOPMENT: "development"
};
var BigBrainClient = /*#__PURE__*/ function() {
    "use strict";
    function BigBrainClient(env, appName, logger, fetchClient, uuidGen) {
        _classCallCheck(this, BigBrainClient);
        this.env = env;
        this.source = appName;
        this.logger = logger;
        this.fetchClient = fetchClient;
        this.uuidGen = uuidGen;
        if (this.env === environments.PRODUCTION) {
            this.bigBrainDomain = "https://track.bigbrain.me/prod";
        } else if (this.env === environments.STAGING) {
            this.bigBrainDomain = "https://track.bigbrainstaging.me/stage";
        } else {
            this.bigBrainDomain = "http://localhost:3002";
            this.source = "test";
        }
        if (!this.source) {
            throw new Error("No appName given");
        }
    }
    _createClass(BigBrainClient, [
        {
            key: "track",
            value: function track(eventName) {
                var eventData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return _asyncToGenerator(function() {
                    var event, error;
                    return _tsGenerator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.env !== environments.PRODUCTION && _this.env !== environments.STAGING) {
                                    _this.logger.info(eventData, "BigBrain event: ".concat(eventName));
                                    return [
                                        2
                                    ];
                                }
                                event = _objectSpread({
                                    name: eventName,
                                    source: _this.source,
                                    uuid: _this.uuidGen.v4()
                                }, eventData);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetchClient("".concat(_this.bigBrainDomain, "/event"), {
                                        method: "POST",
                                        body: JSON.stringify(event),
                                        headers: {
                                            "User-Agent": "monday",
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _this.logger.error({
                                    error: {
                                        message: error.message,
                                        stack: error.stack
                                    },
                                    event: event
                                }, "While trying to send BigBrain track event, caught error");
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BigBrainClient;
}();
module.exports = BigBrainClient;


/***/ }),

/***/ 96842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Skeleton; }
});

// NAMESPACE OBJECT: ./node_modules/uuid/dist/esm-browser/index.js
var esm_browser_namespaceObject = {};
__webpack_require__.r(esm_browser_namespaceObject);
__webpack_require__.d(esm_browser_namespaceObject, {
  "NIL": function() { return nil; },
  "parse": function() { return esm_browser_parse; },
  "stringify": function() { return dist_esm_browser_stringify/* default */.Z; },
  "v1": function() { return esm_browser_v1; },
  "v3": function() { return esm_browser_v3; },
  "v4": function() { return dist_esm_browser_v4/* default */.Z; },
  "v5": function() { return esm_browser_v5; },
  "validate": function() { return esm_browser_validate/* default */.Z; },
  "version": function() { return esm_browser_version; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property/* default */.Z)(target, key, source[key]);
    });
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// EXTERNAL MODULE: ./node_modules/@mondaydotcomorg/bigbrain/node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(95186);
var browser_ponyfill_default = /*#__PURE__*/__webpack_require__.n(browser_ponyfill);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
var esm_browser_rng = __webpack_require__(13653);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js
var dist_esm_browser_stringify = __webpack_require__(3958);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v1.js

 // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || esm_browser_rng/* default */.Z)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0,dist_esm_browser_stringify/* default */.Z)(b);
}

/* harmony default export */ var esm_browser_v1 = (v1);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/validate.js + 1 modules
var esm_browser_validate = __webpack_require__(68697);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/parse.js


function parse(uuid) {
  if (!(0,esm_browser_validate/* default */.Z)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  var v;
  var arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

/* harmony default export */ var esm_browser_parse = (parse);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v35.js



function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];

  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
/* harmony default export */ function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = esm_browser_parse(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0,dist_esm_browser_stringify/* default */.Z)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/md5.js
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';

  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));

  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/* harmony default export */ var esm_browser_md5 = (md5);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v3.js


var v3 = v35('v3', 0x30, esm_browser_md5);
/* harmony default export */ var esm_browser_v3 = (v3);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var dist_esm_browser_v4 = __webpack_require__(72045);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/sha1.js
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);

    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }

    M[_i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);

    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }

    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

/* harmony default export */ var esm_browser_sha1 = (sha1);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v5.js


var v5 = v35('v5', 0x50, esm_browser_sha1);
/* harmony default export */ var esm_browser_v5 = (v5);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/nil.js
/* harmony default export */ var nil = ('00000000-0000-0000-0000-000000000000');
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/version.js


function version(uuid) {
  if (!(0,esm_browser_validate/* default */.Z)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.substr(14, 1), 16);
}

/* harmony default export */ var esm_browser_version = (version);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/index.js









// EXTERNAL MODULE: ./node_modules/@mondaydotcomorg/bigbrain/lib/BigBrainClient.js
var BigBrainClient = __webpack_require__(19811);
var BigBrainClient_default = /*#__PURE__*/__webpack_require__.n(BigBrainClient);
;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/bigbrain/BigBrainWeb.js



var bigBrain = function(env, appName) {
    return new (BigBrainClient_default())(env, appName, console, (browser_ponyfill_default()), esm_browser_namespaceObject);
};

;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/types.js
var AssetType;
(function(AssetType) {
    AssetType[AssetType["js"] = 0] = "js";
    AssetType[AssetType["css"] = 1] = "css";
})(AssetType || (AssetType = {}));
var HostEnvironment;
(function(HostEnvironment) {
    HostEnvironment["development"] = "development";
    HostEnvironment["staging"] = "staging";
    HostEnvironment["production"] = "production";
})(HostEnvironment || (HostEnvironment = {}));
var SkeletonEvent;
(function(SkeletonEvent) {
    SkeletonEvent["SkeletonCreated"] = "skeleton_created";
    // getAllMfs
    SkeletonEvent["GetAllMfsStart"] = "get_all_mfs_start";
    SkeletonEvent["GetAllMfsSuccess"] = "get_all_mfs_success";
    SkeletonEvent["GetAllMfsError"] = "get_all_mfs_error";
    // initialization
    SkeletonEvent["InitMF"] = "init_mf";
    SkeletonEvent["MFLoadStart"] = "mf_load_start";
    SkeletonEvent["PrefetchMF"] = "prefetch_mf";
    // mf assets
    SkeletonEvent["FetchMfAssetsStart"] = "fetch_mf_assets_start";
    SkeletonEvent["FetchMfAssetsSuccess"] = "fetch_mf_assets_success";
    SkeletonEvent["FetchMfAssetsError"] = "fetch_mf_assets_error";
    SkeletonEvent["FetchMfAssetsFallbackSuccess"] = "fetch_mf_assets_fallback_success";
    SkeletonEvent["FetchMfAssetsFallbackError"] = "fetch_mf_assets_fallback_error";
    // meta data
    SkeletonEvent["MFNotInList"] = "mf_not_in_list";
    SkeletonEvent["UseLocalMetaData"] = "use_local_meta_data";
    SkeletonEvent["StartFetchingMetaData"] = "start_fetching_meta_data";
    SkeletonEvent["SuccessFetchingMetaData"] = "success_fetching_meta_data";
    SkeletonEvent["ErrorFetchingMetaData"] = "error_fetching_meta_data";
    // manifest
    SkeletonEvent["StartFetchingManifest"] = "start_fetching_manifest";
    SkeletonEvent["SuccessFetchingManifest"] = "sucess_fetching_manifest";
    SkeletonEvent["ErrorFetchingManifest"] = "error_fetching_manifest";
    SkeletonEvent["FallbackFetchingManifestSuccess"] = "fallback_fetching_manifest_success";
    SkeletonEvent["FallbackFetchingManifestFail"] = "fallback_fetching_manifest_fail";
    // externals
    SkeletonEvent["SharedDependenciesLoadStart"] = "shared_dependencies_load_start";
    SkeletonEvent["SharedDependenciesLoadEnd"] = "shared_dependencies_load_end";
    // loading assets
    SkeletonEvent["StartLoadingJsAssets"] = "start_loading_js_assets";
    SkeletonEvent["SuccessLoadingJsAssets"] = "sucsess_loading_js_assets";
    SkeletonEvent["SuccessLoadingJSAsset"] = "sucsess_loading_js_asset";
    SkeletonEvent["ErrorLoadingJSAsset"] = "error_loading_js_assets";
    SkeletonEvent["SuccessLoadingCSSAsset"] = "sucsess_loading_css_asset";
    SkeletonEvent["ErrorLoadingCSSAsset"] = "error_loading_asset_css";
    // preFetch mf
    SkeletonEvent["StartPreFetchMF"] = "start_prefetch_mf";
    SkeletonEvent["ErrorPreFetchMF"] = "error_prefetch_mf";
    // mf lifecycles
    SkeletonEvent["MfUserInitStart"] = "mf_user_init_start";
    SkeletonEvent["MfUserInitSuccess"] = "mf_user_init_success";
    SkeletonEvent["MfUserInitError"] = "mf_user_init_error";
    SkeletonEvent["MfUserRenderStart"] = "mf_user_render_start";
    SkeletonEvent["MfUserRenderSuccess"] = "mf_user_render_success";
    SkeletonEvent["MfUserRenderError"] = "mf_user_render_error";
    SkeletonEvent["MfUserUpdateInitialDataError"] = "mf_user_update_initial_data_error";
    SkeletonEvent["MfUseruUnmountError"] = "mf_user_unmount_error";
    SkeletonEvent["MFLoadDone"] = "mf_load_done";
})(SkeletonEvent || (SkeletonEvent = {}));


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/tracker/tags.js
var TAGS = {
    isInCanaryExperimentalGroup: "is_in_canary_experimental_group",
    isMfInCanary: "is_mf_in_canary",
    version: "version"
};


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/tracker/transactionsManager.js





var TRANSACTIONS = {
    init: {
        name: "init",
        spans: {
            getAllMfs: "getAllMfs",
            fetchingMetaData: "fetchingMetaData",
            fetchingManifest: "fetchingManifest",
            loadExternals: "loadExternals",
            loadJsAssets: "loadJsAssets",
            userInit: "userInit"
        }
    },
    render: {
        name: "render"
    }
};
var TransactionsManager = /*#__PURE__*/ function() {
    "use strict";
    function TransactionsManager(createTransaction, preloadedMFs) {
        (0,_class_call_check/* default */.Z)(this, TransactionsManager);
        this.transactionsByMf = {};
        this.createTransaction = createTransaction;
        this.preloadedMFs = preloadedMFs;
    }
    (0,_create_class/* default */.Z)(TransactionsManager, [
        {
            key: "getTransactionByMf",
            value: function getTransactionByMf(mfName, transactionName) {
                var transactionsByMf = this.transactionsByMf[mfName];
                return transactionsByMf ? transactionsByMf[transactionName] : null;
            }
        },
        {
            key: "startTransaction",
            value: function startTransaction(mfName, transactionName) {
                var tags = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _a;
                var transaction = this.createTransaction(transactionName, mfName, tags);
                (_a = this.transactionsByMf)[mfName] || (_a[mfName] = {});
                this.transactionsByMf[mfName][transactionName] = transaction;
            }
        },
        {
            key: "finishTransaction",
            value: function finishTransaction(mfName, transactionName) {
                var transaction = this.getTransactionByMf(mfName, transactionName);
                transaction === null || transaction === void 0 ? void 0 : transaction.finish();
            }
        },
        {
            key: "startSpan",
            value: function startSpan(mfName, transactionName, spanName) {
                var transaction = this.getTransactionByMf(mfName, transactionName);
                if (transaction) {
                    this.transactionsByMf[mfName][spanName] = transaction.startChild({
                        op: spanName,
                        description: spanName
                    });
                }
            }
        },
        {
            key: "finishSpan",
            value: function finishSpan(mfName, spanName) {
                if (!mfName || !spanName) {
                    return;
                }
                var span = this.getTransactionByMf(mfName, spanName);
                span === null || span === void 0 ? void 0 : span.finish();
            }
        },
        {
            key: "track",
            value: function track(eventName) {
                var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                var mfName = data.mfName, _mfCanary = data.mfCanary, mfCanary = _mfCanary === void 0 ? {} : _mfCanary, version = data.version;
                var isInCanaryExperimentalGroup = mfCanary.isInCanaryExperimentalGroup, isMfInCanary = mfCanary.isMfInCanary;
                try {
                    switch(eventName){
                        case SkeletonEvent.MFLoadStart:
                            {
                                var _obj;
                                this.startTransaction(mfName, TRANSACTIONS.init.name, (_obj = {}, (0,_define_property/* default */.Z)(_obj, TAGS.isInCanaryExperimentalGroup, isInCanaryExperimentalGroup), (0,_define_property/* default */.Z)(_obj, TAGS.isMfInCanary, isMfInCanary), (0,_define_property/* default */.Z)(_obj, TAGS.version, version), _obj));
                                break;
                            }
                        case SkeletonEvent.MFLoadDone:
                            {
                                this.finishTransaction(mfName, TRANSACTIONS.init.name);
                                break;
                            }
                        case SkeletonEvent.StartFetchingMetaData:
                            {
                                this.startSpan(mfName, TRANSACTIONS.init.name, TRANSACTIONS.init.spans.fetchingMetaData);
                                break;
                            }
                        case SkeletonEvent.SuccessFetchingMetaData:
                            {
                                this.finishSpan(mfName, TRANSACTIONS.init.spans.fetchingMetaData);
                                break;
                            }
                        case SkeletonEvent.StartFetchingManifest:
                            {
                                this.startSpan(mfName, TRANSACTIONS.init.name, TRANSACTIONS.init.spans.fetchingManifest);
                                break;
                            }
                        case SkeletonEvent.SuccessFetchingManifest:
                            {
                                this.finishSpan(mfName, TRANSACTIONS.init.spans.fetchingManifest);
                                break;
                            }
                        case SkeletonEvent.SharedDependenciesLoadStart:
                            {
                                this.startSpan(mfName, TRANSACTIONS.init.name, TRANSACTIONS.init.spans.loadExternals);
                                break;
                            }
                        case SkeletonEvent.SharedDependenciesLoadEnd:
                            {
                                this.finishSpan(mfName, TRANSACTIONS.init.spans.loadExternals);
                                break;
                            }
                        case SkeletonEvent.StartLoadingJsAssets:
                            {
                                this.startSpan(mfName, TRANSACTIONS.init.name, TRANSACTIONS.init.spans.loadJsAssets);
                                break;
                            }
                        case SkeletonEvent.SuccessLoadingJsAssets:
                            {
                                this.finishSpan(mfName, TRANSACTIONS.init.spans.loadJsAssets);
                                break;
                            }
                        case SkeletonEvent.MfUserInitStart:
                            {
                                if (this.preloadedMFs.has(mfName)) {
                                    var _obj1;
                                    this.startTransaction(mfName, TRANSACTIONS.init.name, (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, TAGS.isInCanaryExperimentalGroup, isInCanaryExperimentalGroup), (0,_define_property/* default */.Z)(_obj1, TAGS.isMfInCanary, isMfInCanary), (0,_define_property/* default */.Z)(_obj1, TAGS.version, version), _obj1));
                                }
                                this.startSpan(mfName, TRANSACTIONS.init.name, TRANSACTIONS.init.spans.userInit);
                                break;
                            }
                        case SkeletonEvent.MfUserInitSuccess:
                            {
                                this.finishSpan(mfName, TRANSACTIONS.init.spans.userInit);
                                if (this.preloadedMFs.has(mfName)) {
                                    this.finishTransaction(mfName, TRANSACTIONS.init.name);
                                }
                                break;
                            }
                        case SkeletonEvent.MfUserRenderStart:
                            {
                                this.startTransaction(mfName, TRANSACTIONS.render.name);
                                var observer = new MutationObserver(function(mutationsList) {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        // eslint-disable-next-line no-restricted-syntax
                                        for(var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var mutation = _step.value;
                                            if (mutation.type === "childList") {
                                                _this.finishTransaction(mfName, TRANSACTIONS.render.name);
                                                observer.disconnect();
                                                break;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                });
                                observer.observe(data.element, {
                                    childList: true
                                });
                                break;
                            }
                        default:
                            {
                                break;
                            }
                    }
                } catch (e) {
                    console.error("Failed creating sentry transactions. event: ".concat(eventName, ". data:").concat(JSON.stringify(data)));
                }
            }
        }
    ]);
    return TransactionsManager;
}();


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/tracker/tracker.js








var BIGBRAIN_EVENT_NAME = "trident-metrics";
var BIGBRAIN_SAMPLE_RATE = 1 / 200;
// for Trident internal use only
var Tracker = /*#__PURE__*/ function() {
    "use strict";
    function Tracker(param) {
        var host = param.host, api = param.api, preloadedMFs = param.preloadedMFs;
        (0,_class_call_check/* default */.Z)(this, Tracker);
        var ref, ref1;
        this.uuid = esm_browser_v4();
        this.host = host;
        this.api = api;
        this.bigbrain = bigBrain(host.environment, host.name);
        if (this.host.environment === HostEnvironment.production && ((ref = this.api) === null || ref === void 0 ? void 0 : (ref1 = ref.loggerService) === null || ref1 === void 0 ? void 0 : ref1.startTransaction)) {
            this.transactionsManager = new TransactionsManager(this.api.loggerService.startTransaction, preloadedMFs);
        } else {
            this.transactionsManager = null;
        }
    }
    (0,_create_class/* default */.Z)(Tracker, [
        {
            key: "track",
            value: function track(name) {
                var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.transactionsManager) {
                    this.transactionsManager.track(name, data);
                }
                this.bigbrainSample(name, data);
            }
        },
        {
            key: "cleanBigbrainData",
            value: function cleanBigbrainData(data) {
                var error = data.error;
                return _objectSpreadProps(_objectSpread({}, data), {
                    error: error ? error.message : undefined,
                    element: undefined
                });
            }
        },
        {
            key: "bigbrainSample",
            value: function bigbrainSample(name, data) {
                if (Math.random() < BIGBRAIN_SAMPLE_RATE) {
                    var event = {
                        kind: name,
                        data: _objectSpread({
                            uuid: this.uuid,
                            time: Date.now()
                        }, this.cleanBigbrainData(data))
                    };
                    this.bigbrain.track(BIGBRAIN_EVENT_NAME, event);
                }
            }
        }
    ]);
    return Tracker;
}();


// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/helpers/getResponse.js


function getResponse(url, options) {
    return _getResponse.apply(this, arguments);
}
function _getResponse() {
    _getResponse = _asyncToGenerator(function(url, options) {
        var res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.json()
                    ];
            }
        });
    });
    return _getResponse.apply(this, arguments);
}


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/helpers/index.js





var MF_TEST_VERSION_SEPARATOR = "~";
var MF_ASSETS_FALLBACK_PATH = "/microfrontends/mf_assets";
// eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function
function NOOP() {}
function stripTrailingSlash(str) {
    return str.endsWith("/") ? str.slice(0, -1) : str;
}
function getAllMfData(_) {
    return _getAllMfData.apply(this, arguments);
}
function _getAllMfData() {
    _getAllMfData = _asyncToGenerator(function(param) {
        var testOverridesQueryParams, isAssetsFlattened, mfUrl, mfsToPreload, params, queryParamString;
        return (0,tslib_es6.__generator)(this, function(_state) {
            testOverridesQueryParams = param.testOverridesQueryParams, isAssetsFlattened = param.isAssetsFlattened, mfUrl = param.mfUrl, mfsToPreload = param.mfsToPreload;
            params = query_string.stringify({
                "test_overrides[]": testOverridesQueryParams,
                flatten: isAssetsFlattened || undefined,
                preloaded_mfs: mfsToPreload
            });
            queryParamString = params ? "?".concat(params) : "";
            return [
                2,
                getResponse("".concat(mfUrl, "/allMfData").concat(queryParamString))
            ];
        });
    });
    return _getAllMfData.apply(this, arguments);
}
function groupBy(arr, predicator) {
    var result = {};
    arr.forEach(function(item) {
        var key = predicator(item);
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(item);
    });
    return result;
}
function getMfAssets(_) {
    return _getMfAssets.apply(this, arguments);
}
function _getMfAssets() {
    _getMfAssets = _asyncToGenerator(function(param) {
        var testOverridesQueryParams, mfUrl, _useMfAssetsFallback, useMfAssetsFallback, _emitSkeletonEvent, emitSkeletonEvent, params, queryParamString, result, error, result1, error1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    testOverridesQueryParams = param.testOverridesQueryParams, mfUrl = param.mfUrl, _useMfAssetsFallback = param.useMfAssetsFallback, useMfAssetsFallback = _useMfAssetsFallback === void 0 ? false : _useMfAssetsFallback, _emitSkeletonEvent = param.emitSkeletonEvent, emitSkeletonEvent = _emitSkeletonEvent === void 0 ? NOOP : _emitSkeletonEvent;
                    emitSkeletonEvent(SkeletonEvent.FetchMfAssetsStart);
                    params = query_string.stringify({
                        "test_overrides[]": testOverridesQueryParams
                    });
                    queryParamString = params ? "?".concat(params) : "";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4,
                        getResponse("".concat(mfUrl, "/mf-assets").concat(queryParamString))
                    ];
                case 2:
                    result = _state.sent();
                    emitSkeletonEvent(SkeletonEvent.FetchMfAssetsSuccess);
                    return [
                        2,
                        result
                    ];
                case 3:
                    error = _state.sent();
                    emitSkeletonEvent(SkeletonEvent.FetchMfAssetsError, {
                        error: error
                    });
                    if (!(!testOverridesQueryParams && useMfAssetsFallback)) return [
                        3,
                        7
                    ];
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        getResponse(MF_ASSETS_FALLBACK_PATH)
                    ];
                case 5:
                    result1 = _state.sent();
                    emitSkeletonEvent(SkeletonEvent.FetchMfAssetsFallbackSuccess);
                    return [
                        2,
                        result1
                    ];
                case 6:
                    error1 = _state.sent();
                    emitSkeletonEvent(SkeletonEvent.FetchMfAssetsFallbackError, {
                        error: error1
                    });
                    return [
                        3,
                        7
                    ];
                case 7:
                    throw new Error("Failed to fetch mf-assets");
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return _getMfAssets.apply(this, arguments);
}


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/localDev/index.js
var LOCAL_STORAGE_KEY = "mf-localstorage-dev";
function setLocalMFs(localMfs) {
    try {
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(localMfs));
    } catch (error) {
        console.error("Error setting local MFs", error);
    }
}
function getLocalMFs() {
    try {
        var ref;
        var item = ((ref = window.localStorage) === null || ref === void 0 ? void 0 : ref.getItem(LOCAL_STORAGE_KEY)) || "[]";
        return JSON.parse(item);
    } catch (error) {
        console.error("Error getting local MFs", error);
        return [];
    }
}
function extractLocalMFs() {
    return getLocalMFs().reduce(function(acc, value) {
        acc[value.name] = acc[value.name] || {};
        acc[value.name].endpoint = value.endpoint;
        acc[value.name].version = value.version;
        acc[value.name].active = value.active;
        return acc;
    }, {});
}
function shouldUseLocal(MFname) {
    var ref;
    return ((ref = extractLocalMFs()[MFname]) === null || ref === void 0 ? void 0 : ref.active) || false;
}


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/scripts.js


function loadScript(param) {
    var mfName = param.mfName, src = param.src, _onEvent = param.onEvent, onEvent = _onEvent === void 0 ? NOOP : _onEvent, appendScript = param.appendScript;
    var script = document.createElement("script");
    script.src = src;
    var onLoadPromise = new Promise(function(resolve) {
        script.onload = resolve;
    });
    script.onerror = function() {
        onEvent(SkeletonEvent.ErrorLoadingJSAsset, {
            mfName: mfName,
            src: src,
            mfResource: src
        });
    };
    if (appendScript) {
        appendScript(script);
    } else {
        document.body.appendChild(script);
    }
    return onLoadPromise;
}
function loadStylesheet(param) {
    var mfName = param.mfName, src = param.src, _onEvent = param.onEvent, onEvent = _onEvent === void 0 ? NOOP : _onEvent;
    var link = document.createElement("link");
    link.href = src;
    link.rel = "stylesheet";
    var onLoadPromise = new Promise(function(resolve) {
        link.onload = resolve;
    });
    link.onerror = function() {
        onEvent(SkeletonEvent.ErrorLoadingCSSAsset, {
            mfName: mfName,
            src: src,
            mfResource: src
        });
    };
    document.head.appendChild(link);
    return onLoadPromise;
}
function preloadScript(param) {
    var mfName = param.mfName, src = param.src, _onEvent = param.onEvent, onEvent = _onEvent === void 0 ? NOOP : _onEvent, _assetType = param.assetType, assetType = _assetType === void 0 ? AssetType.js : _assetType, appendScript = param.appendScript;
    var link = document.createElement("link");
    link.href = src;
    link.rel = "preload";
    link.as = assetType === AssetType.js ? "script" : "style";
    var onLoadPromise = new Promise(function(resolve) {
        link.onload = resolve;
    });
    link.onerror = function() {
        onEvent(assetType === AssetType.js ? SkeletonEvent.ErrorLoadingJSAsset : SkeletonEvent.ErrorLoadingCSSAsset, {
            mfName: mfName,
            src: src,
            mfResource: src
        });
    };
    if (appendScript) {
        appendScript(link);
    } else {
        document.body.appendChild(link);
    }
    return onLoadPromise;
}


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/mf/manifestHandler.js







var LoadFilesMode;
(function(LoadFilesMode) {
    LoadFilesMode[LoadFilesMode["preFetchOnly"] = 0] = "preFetchOnly";
    LoadFilesMode[LoadFilesMode["skipPreFetch"] = 1] = "skipPreFetch";
    LoadFilesMode[LoadFilesMode["withPreFetch"] = 2] = "withPreFetch";
})(LoadFilesMode || (LoadFilesMode = {}));
var ManifestHandler = /*#__PURE__*/ function() {
    "use strict";
    function ManifestHandler(param) {
        var emitSkeletonEvent = param.emitSkeletonEvent, sharedDependencies = param.sharedDependencies;
        (0,_class_call_check/* default */.Z)(this, ManifestHandler);
        this.emitSkeletonEvent = emitSkeletonEvent;
        this.sharedDependencies = sharedDependencies;
    }
    (0,_create_class/* default */.Z)(ManifestHandler, [
        {
            key: "loadMfAssets",
            value: function loadMfAssets(param) {
                var mfName = param.mfName, manifest = param.manifest, assetsDir = param.assetsDir, _mode = param.mode, mode = _mode === void 0 ? LoadFilesMode.withPreFetch : _mode, appendScript = param.appendScript;
                var _this = this;
                return _asyncToGenerator(function() {
                    var sharedDependenciesBuckets, mfAssets;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        sharedDependenciesBuckets = _this.getSharedDependenciesBuckets({
                            manifest: manifest
                        });
                        mfAssets = manifest.entrypoints.map(function(entry) {
                            return "".concat(assetsDir, "/").concat(entry);
                        });
                        return [
                            2,
                            _this.loadAssets({
                                mfName: mfName,
                                mode: mode,
                                sharedDependenciesBuckets: sharedDependenciesBuckets,
                                mfAssets: mfAssets,
                                appendScript: appendScript
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "batchLoadMfsAssets",
            value: function batchLoadMfsAssets(param) {
                var mfNames = param.mfNames, mfAssets = param.mfAssets, sharedDependenciesBuckets = param.sharedDependenciesBuckets, _mode = param.mode, mode = _mode === void 0 ? LoadFilesMode.withPreFetch : _mode;
                var _this = this;
                return _asyncToGenerator(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.loadAssets({
                                mfName: mfNames.join(","),
                                mode: mode,
                                sharedDependenciesBuckets: sharedDependenciesBuckets,
                                mfAssets: mfAssets
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "loadAssets",
            value: function loadAssets(param) {
                var mfName = param.mfName, mfAssets = param.mfAssets, sharedDependenciesBuckets = param.sharedDependenciesBuckets, _mode = param.mode, mode = _mode === void 0 ? LoadFilesMode.withPreFetch : _mode, appendScript = param.appendScript;
                var _this = this;
                return _asyncToGenerator(function() {
                    var sharedDependenciesToPreload, assetsLoadTime;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (mode !== LoadFilesMode.skipPreFetch) {
                                    sharedDependenciesToPreload = sharedDependenciesBuckets.flat().filter(function(dep) {
                                        return !_this.sharedDependencies.getDependencyLoadPromise(dep.globalName);
                                    });
                                    _this.preload({
                                        mfAssets: mfAssets,
                                        sharedDependenciesBuckets: [
                                            sharedDependenciesToPreload
                                        ],
                                        mfName: mfName,
                                        appendScript: appendScript
                                    });
                                }
                                if (mode === LoadFilesMode.preFetchOnly) {
                                    return [
                                        2,
                                        {
                                            assetsLoadTime: 0
                                        }
                                    ];
                                }
                                return [
                                    4,
                                    _this.loadSharedDependencies({
                                        mfName: mfName,
                                        sharedDependenciesBuckets: sharedDependenciesBuckets
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.loadManifestAssets({
                                        mfAssets: mfAssets,
                                        mfName: mfName,
                                        appendScript: appendScript
                                    })
                                ];
                            case 2:
                                assetsLoadTime = _state.sent();
                                return [
                                    2,
                                    {
                                        assetsLoadTime: assetsLoadTime
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSharedDependenciesBuckets",
            value: function getSharedDependenciesBuckets(param) {
                var manifest = param.manifest;
                var _this = this;
                var ref = manifest || {}, shared = ref.shared, sameAsHost = ref.sameAsHost;
                // If this MF doesn't support shared dependencies, we don't need to do anything
                if (!(shared === null || shared === void 0 ? void 0 : shared.length)) {
                    return [];
                }
                // This MF asks to forcefully use the dependencies of the host. We won't load its shared dependencies.
                if (sameAsHost === true) {
                    return [];
                }
                var buckets = [];
                shared.forEach(function(param) {
                    var globalName = param.globalName, dependencies = param.dependencies;
                    if (!globalName) {
                        throw new Error('Attempted to load a shared dependency with missing globalName".        This most likely means that the MF has an old Trident version which is no longer supported');
                    }
                    var url = _this.sharedDependencies.getUrl(globalName);
                    var numOfDependencies = Object.keys(dependencies).length;
                    buckets[numOfDependencies] || (buckets[numOfDependencies] = []);
                    buckets[numOfDependencies].push({
                        globalName: globalName,
                        url: url
                    });
                });
                return buckets;
            }
        },
        {
            key: "loadSharedDependencies",
            value: function loadSharedDependencies(param) {
                var sharedDependenciesBuckets = param.sharedDependenciesBuckets, mfName = param.mfName, appendScript = param.appendScript;
                var _this = this;
                return _asyncToGenerator(function() {
                    var startLoadTime, i, depsToLoadNext, loadAllNextSharedDeps;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                startLoadTime = Date.now();
                                _this.emitSkeletonEvent(SkeletonEvent.SharedDependenciesLoadStart, {
                                    mfName: mfName
                                });
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(i < sharedDependenciesBuckets.length)) return [
                                    3,
                                    4
                                ];
                                depsToLoadNext = sharedDependenciesBuckets[i] || [];
                                loadAllNextSharedDeps = Promise.all(depsToLoadNext.map(function(dep) {
                                    return _this.sharedDependencies.ensureDependencyLoadPromise(dep.globalName, function() {
                                        return _this.loadAsset({
                                            mfName: mfName,
                                            src: dep.url,
                                            appendScript: appendScript
                                        });
                                    });
                                }));
                                return [
                                    4,
                                    loadAllNextSharedDeps
                                ];
                            case 2:
                                _state.sent(); // wait for the current bucket to finish loading before start loading the next
                                _state.label = 3;
                            case 3:
                                i++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                _this.emitSkeletonEvent(SkeletonEvent.SharedDependenciesLoadEnd, {
                                    mfName: mfName,
                                    loadTime: Date.now() - startLoadTime
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preload",
            value: function preload(param) {
                var mfAssets = param.mfAssets, sharedDependenciesBuckets = param.sharedDependenciesBuckets, mfName = param.mfName, appendScript = param.appendScript;
                var allSharedDependencies = sharedDependenciesBuckets.flat();
                var sharedDependenciesURLs = allSharedDependencies.map(function(param) {
                    var url = param.url;
                    return url;
                });
                var allJSAssets = (0,_to_consumable_array/* default */.Z)(sharedDependenciesURLs).concat((0,_to_consumable_array/* default */.Z)(mfAssets)).filter(function(url) {
                    return url.endsWith(".js");
                });
                var cssAssets = mfAssets.filter(function(url) {
                    return url.endsWith(".css");
                });
                Promise.all((0,_to_consumable_array/* default */.Z)(allJSAssets.map(function(url) {
                    return preloadScript({
                        mfName: mfName,
                        src: url,
                        appendScript: appendScript
                    });
                })).concat((0,_to_consumable_array/* default */.Z)(cssAssets.map(function(url) {
                    return preloadScript({
                        mfName: mfName,
                        src: url,
                        assetType: AssetType.css
                    });
                })))).catch(function(e) {
                    throw e;
                });
            }
        },
        {
            key: "loadAsset",
            value: function loadAsset(param) {
                var src = param.src, mfName = param.mfName, appendScript = param.appendScript;
                var _this = this;
                return _asyncToGenerator(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!src.endsWith(".js")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    loadScript({
                                        mfName: mfName,
                                        src: src,
                                        onEvent: _this.emitSkeletonEvent,
                                        appendScript: appendScript
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!src.endsWith(".css")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    loadStylesheet({
                                        mfName: mfName,
                                        src: src,
                                        onEvent: _this.emitSkeletonEvent
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadManifestAssets",
            value: function loadManifestAssets(param) {
                var mfAssets = param.mfAssets, mfName = param.mfName, appendScript = param.appendScript;
                var _this = this;
                return _asyncToGenerator(function() {
                    var loadingAssetsStartTime, cssFilesLoadingPromises, ref, cssFiles, jsFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, src, err, totalTime;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.emitSkeletonEvent(SkeletonEvent.StartLoadingJsAssets, {
                                    mfName: mfName
                                });
                                loadingAssetsStartTime = Date.now();
                                cssFilesLoadingPromises = [];
                                ref = mfAssets.reduce(function(acc, fileName) {
                                    if (fileName.endsWith(".js")) {
                                        acc.jsFiles.push(fileName);
                                    } else if (fileName.endsWith(".css")) {
                                        acc.cssFiles.push(fileName);
                                    }
                                    return acc;
                                }, {
                                    cssFiles: [],
                                    jsFiles: []
                                }), cssFiles = ref.cssFiles, jsFiles = ref.jsFiles;
                                cssFiles.forEach(function(src) {
                                    cssFilesLoadingPromises.push(_this.loadAsset({
                                        mfName: mfName,
                                        src: src
                                    }));
                                });
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = jsFiles[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                src = _step.value;
                                return [
                                    4,
                                    _this.loadAsset({
                                        mfName: mfName,
                                        src: src,
                                        appendScript: appendScript
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                _this.emitSkeletonEvent(SkeletonEvent.SuccessLoadingJsAssets, {
                                    mfName: mfName
                                });
                                return [
                                    4,
                                    Promise.all(cssFilesLoadingPromises)
                                ];
                            case 9:
                                _state.sent();
                                totalTime = Date.now() - loadingAssetsStartTime;
                                return [
                                    2,
                                    totalTime
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ManifestHandler;
}();


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/helpers/assetDirUtils.js

function getMFDataFromAssetsDir(mfAssetsDir) {
    var tokens = mfAssetsDir.split("/");
    var version = tokens[tokens.length - 1];
    var name = tokens[tokens.length - 2];
    return {
        name: name,
        version: version
    };
}
function overrideAssetsVersionIfNeeded(param) {
    var mfName = param.mfName, assetsDir = param.assetsDir, manifestPath = param.manifestPath;
    if (!shouldUseLocal(mfName)) {
        return {
            assetsDir: assetsDir,
            manifestPath: manifestPath
        };
    }
    var localMfsConfig = extractLocalMFs();
    var ref = localMfsConfig[mfName] || {}, endpoint = ref.endpoint, version = ref.version;
    if (endpoint) {
        return {
            assetsDir: endpoint,
            manifestPath: "".concat(endpoint, "/asset-manifest.json")
        };
    }
    if (version) {
        if (manifestPath) {
            // overriding the version of asset-manifest
            // i.e "https://microfrontends.monday.com/Docs/latest/asset-manifest.10.json" =>
            // ['https://microfrontends.monday.com/Docs/latest/', '.192.json'] =>
            // "https://microfrontends.monday.com/Docs/latest/asset-manifest.20.json"
            var splitted = manifestPath.split("asset-manifest");
            return {
                assetsDir: assetsDir,
                manifestPath: "".concat(splitted[0], "asset-manifest.").concat(version, ".json")
            };
        }
        // overriding the version with specific one
        // i.e. "https://microfrontends.monday.com/Docs/10" => "https://microfrontends.monday.com/Docs/20"
        var index = assetsDir.lastIndexOf("/");
        var assetsDirRes = "".concat(assetsDir.substring(0, index + 1)).concat(version);
        return {
            assetsDir: assetsDirRes,
            manifestPath: "".concat(assetsDirRes, "/asset-manifest.json")
        };
    }
    return {
        assetsDir: assetsDir,
        manifestPath: manifestPath
    };
}


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/constants.js
var constants_SHARED_DEPENDENCIES_GLOBAL_NAME = "__SHARED_DEPENDENCIES__";


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/SharedDependenciesManager/GlobalSharedDependenciesManager.js




var getSharedDependenciesFromWindow = function() {
    return typeof globalThis[constants_SHARED_DEPENDENCIES_GLOBAL_NAME] !== "undefined" ? globalThis[constants_SHARED_DEPENDENCIES_GLOBAL_NAME] : {};
};
var addSharedDepepndenciesToWindow = function(preloadedSharedDependencies) {
    var existingLoadedSharedDependencies = getSharedDependenciesFromWindow();
    window[SHARED_DEPENDENCIES_GLOBAL_NAME] = _object_spread({}, existingLoadedSharedDependencies, preloadedSharedDependencies);
};
var GlobalSharedDependenciesManager = /*#__PURE__*/ function() {
    "use strict";
    function GlobalSharedDependenciesManager() {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, GlobalSharedDependenciesManager);
        var existingLoadedSharedDependencies = getSharedDependenciesFromWindow();
        this.globalDependencies = new Map();
        Object.keys(existingLoadedSharedDependencies).forEach(function(globalName) {
            // even though the existingLoadedSharedDependencies contains the exact loaded version - we don't need it here.
            // We only care that the version is loaded.
            _this.globalDependencies.set(globalName, {
                loadFrom: "preloaded-from-host",
                loadPromise: Promise.resolve()
            });
        });
    }
    (0,_create_class/* default */.Z)(GlobalSharedDependenciesManager, [
        {
            key: "ensureDependencyLoadPromise",
            value: function ensureDependencyLoadPromise(globalName, load) {
                var globalDep = this.globalDependencies.get(globalName);
                if (!globalDep) {
                    return null;
                }
                globalDep.loadPromise || (globalDep.loadPromise = load());
                return globalDep.loadPromise;
            }
        },
        {
            key: "getDependencyLoadPromise",
            value: function getDependencyLoadPromise(globalName) {
                var globalDep = this.globalDependencies.get(globalName);
                if (!globalDep) {
                    return null;
                }
                return globalDep.loadPromise || null;
            }
        },
        {
            key: "addKnownDependencies",
            value: function addKnownDependencies(globalDeps) {
                var _this = this;
                globalDeps.forEach(function(param) {
                    var globalName = param.globalName, url = param.url;
                    if (_this.globalDependencies.has(globalName)) {
                        // this global dependency is already known - we won't override its state
                        return;
                    }
                    _this.globalDependencies.set(globalName, {
                        loadFrom: url,
                        loadPromise: null
                    });
                });
            }
        },
        {
            key: "getUrl",
            value: function getUrl(globalDep) {
                var details = this.globalDependencies.get(globalDep);
                if (!details) {
                    throw new Error("Attempted getting URL to load of a missing global dependency: ".concat(globalDep));
                }
                return details.loadFrom;
            }
        }
    ]);
    return GlobalSharedDependenciesManager;
}();


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/helpers/cspErrors.js
var CSP_ERROR_MESSAGE = "Failed to fetch";
var LOCALHOST = "localhost";
var CSP_INSTRUCTIONS = "We noticed you had CSP errors while loading a local MF. Please refer to this guide: https://trident.monday.beer/docs/frontend/getting-started/develop-mf#working-with-a-remote-host";
var LOCALHOST_RESOURCE_REGEX = /https?:\/\/localhost/;
function isCspErrorForResource(error, failedResourceUrl) {
    var isCspError = typeof error === "object" && error.message === CSP_ERROR_MESSAGE;
    if (!isCspError) {
        return false;
    }
    var isLocalhostRequest = LOCALHOST_RESOURCE_REGEX.test(failedResourceUrl);
    var isLocalhostHost = window.location.hostname === LOCALHOST;
    return isLocalhostRequest && !isLocalhostHost;
}
function showCspErrorInstructions() {
    // eslint-disable-next-line no-console
    console.log("\n======================\n".concat(CSP_INSTRUCTIONS, "\n======================\n"));
    // eslint-disable-next-line no-alert
    alert(CSP_INSTRUCTIONS);
}


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/mf/mf.js










var Mf = /*#__PURE__*/ function() {
    "use strict";
    function Mf(param) {
        var name = param.name, initConfig = param.initConfig, skeletonContext = param.skeletonContext, mfCanary = param.mfCanary, version = param.version;
        (0,_class_call_check/* default */.Z)(this, Mf);
        this.preFetched = false;
        var _this = this;
        this.onManifestFetchFailure = function() {
            var _ref = _asyncToGenerator(function(error, manifestURL, mfName, assetsDir, timeStart) {
                var _skeletonContext, isDev, emitSkeletonEvent, fallbackResourceFunction, skeleton, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (isCspErrorForResource(error, manifestURL)) {
                                showCspErrorInstructions();
                            }
                            _skeletonContext = _this.skeletonContext, isDev = _skeletonContext.isDev, emitSkeletonEvent = _skeletonContext.emitSkeletonEvent, fallbackResourceFunction = _skeletonContext.fallbackResourceFunction, skeleton = _skeletonContext.skeleton;
                            if (isDev) {
                                console.log("Failed getting from S3, trying from fallback");
                            }
                            emitSkeletonEvent(SkeletonEvent.ErrorFetchingManifest, {
                                mfName: mfName,
                                error: error,
                                manifestURL: manifestURL
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fallbackResourceFunction(skeleton, {
                                    mfName: mfName,
                                    mfResource: assetsDir,
                                    timeStart: timeStart
                                })
                            ];
                        case 2:
                            _state.sent();
                            emitSkeletonEvent(SkeletonEvent.FallbackFetchingManifestSuccess, {
                                mfName: mfName,
                                error: error,
                                manifestURL: manifestURL
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            emitSkeletonEvent(SkeletonEvent.FallbackFetchingManifestFail, {
                                mfName: mfName,
                                error: error,
                                manifestURL: manifestURL
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(error, manifestURL, mfName, assetsDir, timeStart) {
                return _ref.apply(this, arguments);
            };
        }();
        this.name = name;
        this.skeletonContext = skeletonContext;
        this.mfCanary = mfCanary || {
            isInCanaryExperimentalGroup: false,
            isMfInCanary: false
        };
        this.version = version;
        this.initType = initConfig.type;
        if (initConfig.type === "preloaded") {
            this.handleLoadedEntrypointScripts(initConfig.entrypoints);
        } else if (initConfig.type === "withAssetsDir") {
            this.assetsDir = initConfig.assetsDir;
            this.manifestPath = initConfig.manifestPath || "".concat(stripTrailingSlash(initConfig.assetsDir), "/asset-manifest.json");
        } else if (initConfig.type === "withAssetsData") {
            this.assetsManifest = initConfig.manifest;
            this.assetsDir = initConfig.assetsDir;
        } else {
            throw new Error('Unexpected initialization type for MF "'.concat(this.name, '": "').concat(initConfig.type, '"'));
        }
    }
    (0,_create_class/* default */.Z)(Mf, [
        {
            key: "render",
            value: function render(element) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!this.mfInterface) {
                    return;
                }
                var emitSkeletonEvent = this.skeletonContext.emitSkeletonEvent;
                try {
                    emitSkeletonEvent(SkeletonEvent.MfUserRenderStart, {
                        mfName: this.name,
                        element: element
                    });
                    this.mfInterface.render(element, options);
                    emitSkeletonEvent(SkeletonEvent.MfUserRenderSuccess, {
                        mfName: this.name
                    });
                } catch (e) {
                    emitSkeletonEvent(SkeletonEvent.MfUserRenderError, {
                        mfName: this.name,
                        error: e
                    });
                }
            }
        },
        {
            key: "preFetch",
            value: function preFetch() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var emitSkeletonEvent, assetsDir, manifest, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.preFetched || _this.initOncePromise) {
                                    return [
                                        2
                                    ];
                                }
                                emitSkeletonEvent = _this.skeletonContext.emitSkeletonEvent;
                                if (!_this.validateAssetsDataInput() || !_this.validateAssetsDirInput()) {
                                    emitSkeletonEvent(SkeletonEvent.ErrorPreFetchMF, {
                                        mfName: _this.name,
                                        error: new Error("Attempt to prefetch MF: ".concat(_this.name, " with a missing params. assetsDir: ").concat(_this.assetsDir, ", manifestPath: ").concat(_this.manifestPath))
                                    });
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                _this.preFetched = true;
                                assetsDir = stripTrailingSlash(_this.assetsDir);
                                if (!(_this.initType === "withAssetsData")) return [
                                    3,
                                    2
                                ];
                                manifest = _this.assetsManifest;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    getResponse(_this.manifestPath, {
                                        mode: "cors"
                                    })
                                ];
                            case 3:
                                manifest = _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _this.skeletonContext.manifestHandler.loadMfAssets({
                                        mfName: _this.name,
                                        manifest: manifest,
                                        assetsDir: assetsDir,
                                        mode: LoadFilesMode.preFetchOnly
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                emitSkeletonEvent(SkeletonEvent.ErrorPreFetchMF, {
                                    mfName: _this.name,
                                    error: error
                                });
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initOnce",
            value: function initOnce(timeStart, appendScript) {
                var _this = this;
                return _asyncToGenerator(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        _this.initOncePromise || (_this.initOncePromise = _this.initOnceImpl(timeStart, appendScript));
                        return [
                            2,
                            _this.initOncePromise
                        ];
                    });
                })();
            }
        },
        {
            key: "validateAssetsDirInput",
            value: function validateAssetsDirInput() {
                return !(this.initType === "withAssetsDir" && (!this.assetsDir || !this.manifestPath));
            }
        },
        {
            key: "validateAssetsDataInput",
            value: function validateAssetsDataInput() {
                return !(this.initType === "withAssetsData" && (!this.assetsManifest || Object.keys(this.assetsManifest).length === 0 || !this.assetsDir));
            }
        },
        {
            key: "validateInputByInitType",
            value: function validateInputByInitType() {
                if (!this.validateAssetsDirInput()) {
                    throw new Error("Attempt to initialize MF: ".concat(this.name, " with a missing params. init type: ").concat(this.initType, " assetsDir: ").concat(this.assetsDir, ", manifestPath: ").concat(this.manifestPath, "\nThis probably means that an MF was preloaded and attempted to be initialized afterwards."));
                }
                if (!this.validateAssetsDataInput()) {
                    throw new Error("Attempt to initialize MF: ".concat(this.name, ", init type: ").concat(this.initType, " with a missing assets manifest."));
                }
            }
        },
        {
            key: "initOnceImpl",
            value: function initOnceImpl(timeStart, appendScript) {
                var _this = this;
                return _asyncToGenerator(function() {
                    var emitSkeletonEvent, assetsDir, ref, manifest, error, manifest1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.mfInterface) {
                                    return [
                                        2,
                                        _this.mfInterface
                                    ];
                                }
                                _this.validateInputByInitType();
                                emitSkeletonEvent = _this.skeletonContext.emitSkeletonEvent;
                                emitSkeletonEvent(SkeletonEvent.MFLoadStart, {
                                    mfName: _this.name,
                                    mfCanary: _this.mfCanary,
                                    version: _this.version
                                });
                                assetsDir = stripTrailingSlash(_this.assetsDir);
                                if (!(_this.initType === "withAssetsDir")) return [
                                    3,
                                    7
                                ];
                                emitSkeletonEvent(SkeletonEvent.StartFetchingManifest, {
                                    mfName: _this.name,
                                    version: ((ref = _this.version) === null || ref === void 0 ? void 0 : ref.toString()) || "",
                                    mfResource: assetsDir
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    getResponse(_this.manifestPath, {
                                        mode: "cors"
                                    })
                                ];
                            case 2:
                                manifest = _state.sent();
                                emitSkeletonEvent(SkeletonEvent.SuccessFetchingManifest, {
                                    mfName: _this.name
                                });
                                return [
                                    4,
                                    _this.handleManifestFiles({
                                        manifest: manifest,
                                        assetsDir: assetsDir,
                                        timeStart: timeStart,
                                        appendScript: appendScript
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                error = _state.sent();
                                return [
                                    4,
                                    _this.onManifestFetchFailure(error, _this.manifestPath, _this.name, assetsDir, timeStart)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    10
                                ];
                            case 7:
                                if (!(_this.initType === "withAssetsData")) return [
                                    3,
                                    9
                                ];
                                manifest1 = {
                                    shared: _this.assetsManifest.shared,
                                    entrypoints: _this.assetsManifest.entrypoints,
                                    sameAsHost: _this.assetsManifest.sameAsHost || false
                                };
                                return [
                                    4,
                                    _this.handleManifestFiles({
                                        manifest: manifest1,
                                        assetsDir: assetsDir,
                                        timeStart: timeStart,
                                        appendScript: appendScript
                                    })
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                throw new Error('Unexpected initialization type for MF "'.concat(_this.name, '": "').concat(_this.initType, '"'));
                            case 10:
                                return [
                                    2,
                                    _this.mfInterface
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleManifestFiles",
            value: function handleManifestFiles(param) {
                var manifest = param.manifest, assetsDir = param.assetsDir, timeStart = param.timeStart, appendScript = param.appendScript;
                var _this = this;
                return _asyncToGenerator(function() {
                    var assetsLoadTime;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!manifest) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.skeletonContext.manifestHandler.loadMfAssets({
                                        mfName: _this.name,
                                        manifest: manifest,
                                        assetsDir: assetsDir,
                                        mode: _this.preFetched ? LoadFilesMode.skipPreFetch : LoadFilesMode.withPreFetch,
                                        appendScript: appendScript
                                    })
                                ];
                            case 1:
                                assetsLoadTime = _state.sent().assetsLoadTime;
                                _this.handleLoadedEntrypointScripts(manifest.entrypoints);
                                _this.skeletonContext.emitSkeletonEvent(SkeletonEvent.MFLoadDone, {
                                    mfName: _this.name,
                                    totalLoadTime: Date.now() - timeStart,
                                    assetsLoadTime: assetsLoadTime
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleLoadedEntrypointScripts",
            value: function handleLoadedEntrypointScripts(entrypoints) {
                var mfFile = entrypoints.find(function(entry) {
                    return entry.startsWith("MF-");
                });
                if (!mfFile) {
                    throw new Error('No Main MF file found for MF: "'.concat(this.name, '"'));
                }
                var _skeletonContext = this.skeletonContext, emitSkeletonEvent = _skeletonContext.emitSkeletonEvent, mfApi = _skeletonContext.mfApi;
                var ref = (0,_sliced_to_array/* default */.Z)(mfFile.split("."), 1), mfUuid = ref[0];
                var mfInterface = window[mfUuid];
                try {
                    this.mfInterface = mfInterface;
                    var eventData = {
                        mfUuid: mfUuid,
                        mfName: this.name
                    };
                    emitSkeletonEvent(SkeletonEvent.MfUserInitStart, eventData);
                    mfInterface.init({
                        api: mfApi
                    });
                    emitSkeletonEvent(SkeletonEvent.MfUserInitSuccess, eventData);
                } catch (e) {
                    emitSkeletonEvent(SkeletonEvent.MfUserInitError, {
                        error: e,
                        mfName: this.name
                    });
                }
            }
        }
    ]);
    return Mf;
}();


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/helpers/canaryUtils.js
var getRandomPercentage = function() {
    return Math.round(Math.random() * 100);
};
var normalizedCanaryPercentage = function(canaryPercentage) {
    if (canaryPercentage > 100) {
        return 100;
    }
    if (canaryPercentage < 0) {
        return 0;
    }
    return canaryPercentage;
};


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/helpers/localStorage.js
var getItem = function(key) {
    try {
        var item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    } catch (e) {
        return null;
    }
};
var setItem = function(key, value) {
    if (!localStorage) {
        return;
    }
    localStorage.setItem(key, JSON.stringify(value));
};
var isLocalStorageAvailable = function() {
    return localStorage ? true : false;
};


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/CanaryManager/canaryManager.js





var CANARY_LOCAL_STORAGE_KEY = "mfs-canary";
var CanaryManager = /*#__PURE__*/ function() {
    "use strict";
    function CanaryManager() {
        (0,_class_call_check/* default */.Z)(this, CanaryManager);
    }
    (0,_create_class/* default */.Z)(CanaryManager, [
        {
            key: "isInCanary",
            value: function isInCanary(mfName, canaryMetaData) {
                if (!canaryMetaData || !isLocalStorageAvailable()) {
                    return false;
                }
                var canaryPercentage = this.getCanaryPercentage(canaryMetaData);
                var userCanaryExperimentalPercentage = this.getAndSetUserCanaryExperimentalGroup(mfName, canaryMetaData.version);
                return canaryPercentage >= userCanaryExperimentalPercentage;
            }
        },
        {
            key: "getCanaryPercentage",
            value: function getCanaryPercentage(canaryMetaData) {
                var startTimestamp = canaryMetaData.startTimestamp, endTimestamp = canaryMetaData.endTimestamp;
                var totalCanaryDuration = new Date(endTimestamp).valueOf() - new Date(startTimestamp).valueOf();
                var durationFromCanaryStart = new Date().valueOf() - new Date(startTimestamp).valueOf();
                var percentage = Math.round(durationFromCanaryStart / totalCanaryDuration * 100);
                return normalizedCanaryPercentage(percentage);
            }
        },
        {
            key: "getAndSetUserCanaryExperimentalGroup",
            value: function getAndSetUserCanaryExperimentalGroup(mfName, version) {
                var ref;
                var canariesExperimentalPercentage = getItem(CANARY_LOCAL_STORAGE_KEY) || {};
                var canaryPercentage = (ref = canariesExperimentalPercentage[mfName]) === null || ref === void 0 ? void 0 : ref[version];
                if (canaryPercentage) {
                    return canaryPercentage;
                }
                canaryPercentage = getRandomPercentage();
                canariesExperimentalPercentage[mfName] = (0,_define_property/* default */.Z)({}, version, canaryPercentage);
                setItem(CANARY_LOCAL_STORAGE_KEY, canariesExperimentalPercentage);
                return canaryPercentage;
            }
        }
    ]);
    return CanaryManager;
}();


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/helpers/queryHelper.js

function getMFTestVersionFromURLParams() {
    var queryParams = (0,query_string.parse)(window.location.search);
    return queryParams.mf_test_version;
}


;// CONCATENATED MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/index.js
















var Skeleton = /*#__PURE__*/ function() {
    "use strict";
    function Skeleton(param) {
        var api = param.api, mfUrl = param.mfUrl, _preloadedMFs = param.preloadedMFs, preloadedMFs = _preloadedMFs === void 0 ? {} : _preloadedMFs, _isDev = param.isDev, isDev = _isDev === void 0 ? false : _isDev, _mfTestVersion = param.mfTestVersion, mfTestVersion = _mfTestVersion === void 0 ? getMFTestVersionFromURLParams() : _mfTestVersion, _fallbackResourceFunction = param.fallbackResourceFunction, fallbackResourceFunction = _fallbackResourceFunction === void 0 ? NOOP : _fallbackResourceFunction, _onEvent = param.onEvent, onEvent = _onEvent === void 0 ? NOOP : _onEvent, host = param.host, _isAssetsFlattened = param.isAssetsFlattened, isAssetsFlattened = _isAssetsFlattened === void 0 ? false : _isAssetsFlattened, allMfData = param.allMfData, mfAssets = param.mfAssets, _shouldUseMfAssetsEndpoint = param.shouldUseMfAssetsEndpoint, shouldUseMfAssetsEndpoint = _shouldUseMfAssetsEndpoint === void 0 ? false : _shouldUseMfAssetsEndpoint, _useMfAssetsFallback = param.useMfAssetsFallback, useMfAssetsFallback = _useMfAssetsFallback === void 0 ? false : _useMfAssetsFallback;
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, Skeleton);
        this.canaryManager = new CanaryManager();
        this.emitEvent = function(type, data) {
            _this.tracker.track(type, data);
            _this.onEvent(type, data);
        };
        var _this1 = this;
        this.renderMF = function() {
            var _ref = _asyncToGenerator(function(mfName, element) {
                var options, mf;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    mf = _this1.mfs.get(mfName);
                    if (!mf) {
                        console.warn("Tried to render a non-existing MF: ".concat(mfName));
                        return [
                            2
                        ];
                    }
                    mf.render(element, options);
                    return [
                        2
                    ];
                });
            });
            return function(mfName, element) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = this;
        this.ensureMfInstance = function() {
            var _ref = _asyncToGenerator(function(mfName) {
                var assetsDir, mf;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!_this2.mfs.has(mfName)) return [
                                3,
                                2
                            ];
                            // the mfs' data might not be loaded yet - ensure initialization before continuing
                            return [
                                4,
                                _this2.initializeMfsPromise
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            if (!_this2.mfs.has(mfName)) {
                                assetsDir = _this2.getLocalMfAssetsDir(mfName);
                                mf = new Mf({
                                    name: mfName,
                                    skeletonContext: _this2.context,
                                    initConfig: {
                                        type: "withAssetsDir",
                                        assetsDir: assetsDir
                                    }
                                });
                                _this2.mfs.set(mfName, mf);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(mfName) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this3 = this;
        this.preFetchMF = function() {
            var _ref = _asyncToGenerator(function(mfName) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this3.emitEvent(SkeletonEvent.PrefetchMF, {
                                mfName: mfName
                            });
                            return [
                                4,
                                _this3.ensureMfInstance(mfName)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                _this3.mfs.get(mfName).preFetch()
                            ];
                    }
                });
            });
            return function(mfName) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this4 = this;
        this.initMF = function() {
            var _ref = _asyncToGenerator(function(mfName, appendScript) {
                var timeStart;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this4.emitEvent(SkeletonEvent.InitMF, {
                                mfName: mfName,
                                initializedMFs: (0,_to_consumable_array/* default */.Z)(_this4.mfs.keys())
                            });
                            timeStart = Date.now();
                            return [
                                4,
                                _this4.ensureMfInstance(mfName)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                _this4.mfs.get(mfName).initOnce(timeStart, appendScript)
                            ];
                    }
                });
            });
            return function(mfName, appendScript) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this5 = this;
        this.handleManifestFiles = function() {
            var _ref = _asyncToGenerator(function(mfName, manifest, mfResource, param) {
                var timeStart, mf;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            timeStart = param.timeStart;
                            mf = _this5.mfs.get(mfName);
                            if (!mf) {
                                console.warn("Tried to handle manifest files for a non-existing MF: ".concat(mfName));
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                mf.handleManifestFiles({
                                    manifest: manifest,
                                    assetsDir: mfResource,
                                    timeStart: timeStart
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(mfName, manifest, mfResource, _) {
                return _ref.apply(this, arguments);
            };
        }();
        this.mfUrl = mfUrl;
        this.allMfData = allMfData;
        this.isAssetsFlattened = isAssetsFlattened;
        this.onEvent = onEvent;
        var emitSkeletonEvent = this.emitEvent.bind(this);
        this.globalSharedDependencies = new GlobalSharedDependenciesManager();
        this.mfs = new Map();
        var manifestHandler = new ManifestHandler({
            emitSkeletonEvent: emitSkeletonEvent,
            sharedDependencies: this.globalSharedDependencies
        });
        this.context = {
            skeleton: this,
            isDev: isDev,
            fallbackResourceFunction: fallbackResourceFunction,
            emitSkeletonEvent: emitSkeletonEvent,
            mfApi: api,
            manifestHandler: manifestHandler
        };
        this.tracker = new Tracker({
            host: host,
            api: api,
            preloadedMFs: new Set(Object.keys(preloadedMFs))
        });
        this.emitEvent(SkeletonEvent.SkeletonCreated, {
            preloaded: preloadedMFs
        });
        this.mfTestVersion = parseTestVersion(mfTestVersion);
        this.handlePreloadedMfs(preloadedMFs); // initialize the preloaded MFs before start fetching the MF data, to prevent race conditions
        this.initializeMfsPromise = this.fetchMfsData({
            shouldUseMfAssetsEndpoint: shouldUseMfAssetsEndpoint,
            mfAssets: mfAssets,
            allMfData: allMfData,
            useMfAssetsFallback: useMfAssetsFallback
        });
    }
    (0,_create_class/* default */.Z)(Skeleton, [
        {
            key: "fetchMfsData",
            value: function fetchMfsData(param) {
                var shouldUseMfAssetsEndpoint = param.shouldUseMfAssetsEndpoint, mfAssets = param.mfAssets, allMfData = param.allMfData, _useMfAssetsFallback = param.useMfAssetsFallback, useMfAssetsFallback = _useMfAssetsFallback === void 0 ? false : _useMfAssetsFallback;
                var _this = this;
                return _asyncToGenerator(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2,
                            shouldUseMfAssetsEndpoint ? _this.fetchCurrentMfsWithAssets(mfAssets, useMfAssetsFallback) : _this.fetchCurrentMfs(allMfData)
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchCurrentMfs",
            value: function fetchCurrentMfs(allMfData) {
                var _this = this;
                return _asyncToGenerator(function() {
                    var mfs, globalSharedDependencies, ref, metaData, sharedDependencyLocations, _tmp, dependencyDetails;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfs = _this.mfs, globalSharedDependencies = _this.globalSharedDependencies;
                                _tmp = allMfData;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    getAllMfData({
                                        testOverridesQueryParams: _this.testOverridesQueryParams,
                                        mfUrl: _this.mfUrl,
                                        isAssetsFlattened: _this.isAssetsFlattened
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                ref = _tmp, metaData = ref.metaData, sharedDependencyLocations = ref.sharedDependencyLocations;
                                Object.entries(metaData).forEach(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), name = _param[0], currentMetadata = _param[1];
                                    var isInCanaryExperimentalGroup = _this.canaryManager.isInCanary(name, currentMetadata.canary);
                                    var isMfInCanary = !!currentMetadata.canary;
                                    var metadata = isInCanaryExperimentalGroup ? currentMetadata.canary : currentMetadata;
                                    if (mfs.has(name)) {
                                        return;
                                    }
                                    var assetsDirRaw = _this.isAssetsFlattened && metadata.assetsPath ? metadata.assetsPath : metadata.path;
                                    var ref = overrideAssetsVersionIfNeeded({
                                        mfName: name,
                                        assetsDir: assetsDirRaw,
                                        manifestPath: _this.isAssetsFlattened ? metadata.manifestPath : undefined
                                    }), assetsDir = ref.assetsDir, manifestPath = ref.manifestPath;
                                    var mf = new Mf({
                                        name: name,
                                        initConfig: {
                                            type: "withAssetsDir",
                                            assetsDir: assetsDir,
                                            manifestPath: manifestPath
                                        },
                                        mfCanary: {
                                            isInCanaryExperimentalGroup: isInCanaryExperimentalGroup,
                                            isMfInCanary: isMfInCanary
                                        },
                                        version: metadata.version,
                                        skeletonContext: _this.context
                                    });
                                    mfs.set(name, mf);
                                });
                                dependencyDetails = Object.entries(sharedDependencyLocations).map(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), globalName = _param[0], url = _param[1];
                                    return {
                                        globalName: globalName,
                                        url: url
                                    };
                                });
                                globalSharedDependencies.addKnownDependencies(dependencyDetails);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchCurrentMfsWithAssets",
            value: function fetchCurrentMfsWithAssets(mfAssets, useMfAssetsFallback) {
                var _this = this;
                return _asyncToGenerator(function() {
                    var mfs, globalSharedDependencies, ref, assets, sharedDependencyLocations, _tmp, dependencyDetails;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfs = _this.mfs, globalSharedDependencies = _this.globalSharedDependencies;
                                _tmp = mfAssets;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    getMfAssets({
                                        testOverridesQueryParams: _this.testOverridesQueryParams,
                                        mfUrl: _this.mfUrl,
                                        useMfAssetsFallback: useMfAssetsFallback,
                                        emitSkeletonEvent: _this.emitEvent
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                ref = _tmp, assets = ref.assets, sharedDependencyLocations = ref.sharedDependencyLocations;
                                Object.entries(assets).forEach(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), name = _param[0], currentMetadata = _param[1];
                                    if (mfs.has(name)) {
                                        return;
                                    }
                                    var isInCanaryExperimentalGroup = _this.canaryManager.isInCanary(name, currentMetadata.canary);
                                    var isMfInCanary = !!currentMetadata.canary;
                                    var metadata = isInCanaryExperimentalGroup ? currentMetadata.canary : currentMetadata;
                                    if (shouldUseLocal(name)) {
                                        var assetsDirRaw = metadata.url;
                                        var ref = overrideAssetsVersionIfNeeded({
                                            mfName: name,
                                            assetsDir: assetsDirRaw,
                                            manifestPath: _this.isAssetsFlattened ? metadata.url : undefined
                                        }), assetsDir = ref.assetsDir, manifestPath = ref.manifestPath;
                                        var mf = new Mf({
                                            name: name,
                                            initConfig: {
                                                type: "withAssetsDir",
                                                assetsDir: assetsDir,
                                                manifestPath: manifestPath
                                            },
                                            mfCanary: {
                                                isInCanaryExperimentalGroup: isInCanaryExperimentalGroup,
                                                isMfInCanary: isMfInCanary
                                            },
                                            version: metadata.version,
                                            skeletonContext: _this.context
                                        });
                                        mfs.set(name, mf);
                                        return;
                                    }
                                    var mf1 = new Mf({
                                        name: name,
                                        initConfig: {
                                            type: "withAssetsData",
                                            assetsDir: metadata.url,
                                            manifest: metadata
                                        },
                                        mfCanary: {
                                            isInCanaryExperimentalGroup: isInCanaryExperimentalGroup,
                                            isMfInCanary: isMfInCanary
                                        },
                                        version: metadata.version,
                                        skeletonContext: _this.context
                                    });
                                    mfs.set(name, mf1);
                                });
                                dependencyDetails = Object.entries(sharedDependencyLocations).map(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), globalName = _param[0], url = _param[1];
                                    return {
                                        globalName: globalName,
                                        url: url
                                    };
                                });
                                globalSharedDependencies.addKnownDependencies(dependencyDetails);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handlePreloadedMfs",
            value: function handlePreloadedMfs(preloadedMFs) {
                var _this = this;
                Object.entries(preloadedMFs).filter(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 1), name = _param[0];
                    return !shouldUseLocal(name);
                }).forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), name = _param[0], entrypoints = _param[1];
                    var mf = new Mf({
                        name: name,
                        skeletonContext: _this.context,
                        initConfig: {
                            type: "preloaded",
                            entrypoints: entrypoints
                        }
                    });
                    _this.mfs.set(name, mf);
                });
            }
        },
        {
            key: "getLocalMfAssetsDir",
            value: function getLocalMfAssetsDir(mfName) {
                // When using a local setup for an MF that was not deployed yet, it's possible that the MF still does not exist
                var endpoint = (shouldUseLocal(mfName) ? extractLocalMFs()[mfName] || {} : {}).endpoint;
                if (!endpoint) {
                    this.emitEvent(SkeletonEvent.MFNotInList, {
                        mfName: mfName
                    });
                    throw new Error("'".concat(mfName, "' does not exist in Micro frontends list"));
                }
                return endpoint;
            }
        },
        {
            key: "testOverridesQueryParams",
            get: function get() {
                if (!this.mfTestVersion) {
                    return undefined;
                }
                var _mfTestVersion = this.mfTestVersion, mfName = _mfTestVersion.mfName, version = _mfTestVersion.version, testEnvOverride = _mfTestVersion.testEnvOverride;
                var override = "".concat(mfName, "~").concat(version);
                var testEnvOverrideParam = testEnvOverride ? "~".concat(testEnvOverride) : "";
                return "".concat(override).concat(testEnvOverrideParam);
            }
        }
    ]);
    return Skeleton;
}();
function parseTestVersion(mfTestVersion) {
    if (!mfTestVersion || [
        "null",
        "null~undefined"
    ].includes(mfTestVersion)) {
        return undefined;
    }
    // overriding with test version i.e. "https://microfrontends.monday.com/Docs/10" => "https://microfrontends.monday.com/tests/Docs/3"
    var ref = (0,_sliced_to_array/* default */.Z)(mfTestVersion.split(MF_TEST_VERSION_SEPARATOR), 3), mfName = ref[0], version = ref[1], testEnvOverride = ref[2];
    return {
        mfName: mfName,
        version: version,
        testEnvOverride: testEnvOverride
    };
}



/***/ }),

/***/ 17563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

const strictUriEncode = __webpack_require__(70610);
const decodeComponent = __webpack_require__(44020);
const splitOnFirst = __webpack_require__(80500);
const filterObject = __webpack_require__(92806);

const isNullOrUndefined = value => value === null || value === undefined;

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'colon-list-separator':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), ':list='].join('')];
				}

				return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator' ?
				'[]=' :
				'=';

			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'colon-list-separator':
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return (key, value, accumulator) => {
				const isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null ?
					[] :
					value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};


/***/ }),

/***/ 80500:
/***/ (function(module) {

"use strict";


module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ 70610:
/***/ (function(module) {

"use strict";

module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ }),

/***/ 13653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ rng; }
/* harmony export */ });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ 3958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _validate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0,_validate_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ __webpack_exports__["Z"] = (stringify);

/***/ }),

/***/ 72045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _rng_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13653);
/* harmony import */ var _stringify_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3958);



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || _rng_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0,_stringify_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(rnds);
}

/* harmony default export */ __webpack_exports__["Z"] = (v4);

/***/ }),

/***/ 68697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_validate; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);

/***/ })

}]);